// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"580":"4ed894c50488d7e6","1437":"fabcbf9017c3e5ac","1443":"870c12c8c84a96f2","2506":"ff46e2f161ec9864","3709":"56627db9a18fec98","4314":"c49dab28571aec44","4542":"95b10c0591fd1c78","4822":"7aa3ef9bc9182640","5634":"a61d64bd631fbc8c","8623":"59c91be38a20124a"}[chunkId] + ".css";
};